import { Images } from 'assets/images/';
import { StartYourTrip } from 'components';
import {
  GlobalizationImage,
  StartButtonContnet,
  StartTrip,
  StepsDescription,
  StepsSectionContainer,
  TripText,
} from './styled';

export const StepsSection = () => (
  <StepsSectionContainer>
    <StepsDescription>
      <StartTrip>
        <TripText>
          Our AI Hero designs individual travel packages for various purposes so you
          can stop worrying about finding the cheapest air tickets, most stunning
          stays and extraordinary activities.
        </TripText>

        <StartButtonContnet>
          <StartYourTrip />
        </StartButtonContnet>
      </StartTrip>

      <GlobalizationImage src={Images.globalization} alt="icon" />
    </StepsDescription>
    {/* todo open after release */}
    {/* <div className="viewed-section">
      <p className="title">Recently Viewed</p>

      <div className="view-card-wrapper">
        <div className="view-card">
          <div>
            <img className="place-image" src={Images.italy} alt="place" />
          </div>

          <div>
            <div className="name-price-wrapper">
              <div>
                <p className="name">Venice, Italy</p>
                <img src={Images.stars} alt="stars" />
              </div>
              <p className="price">$ 750</p>
            </div>

            <div className="info-wrapper">
              <p>
                <b>Description:</b> Lorem Ipsum is simply dummy text of the Printing
                and typesetting industry. Lorem Ipsum has been the Industrys standard
                dummy text ever since the 1500s, when an unknown Printer took a
                galley of type and scrambled it to make a type Specimen book. It has
                survived not only five centuries, but also The leap into electronic
                typesetting, remaining essentially Unchanged.
              </p>
              <p>
                <b>Country, City:</b> Italy, Venice
              </p>
              <p>
                <b>Population:</b> 2.553 million
              </p>
              <p>
                <b>Healthcare:</b> test
              </p>
              <p>
                <b>Language:</b> English
              </p>
              <a href="https//www.booking.com/">
                <b>Booking URL:</b>
                Https//www.booking.com/{' '}
              </a>
              <a href="https//www.ticket.com/">
                <b> Ticket URL:</b> https//www.ticket.com/
              </a>
              <p>
                <b>Package Name:</b> Yerevan/Active
              </p>
            </div>
          </div>
        </div>
      </div>
    </div> */}
  </StepsSectionContainer>
);
